import axios from 'axios'

const state = {
  tel: '',
  hasLogin: false,
  isRequestingOtp: false,
  otp: '',
  member: null,
  memberId: '',
  authExpired: ''
}

const actions = {
  SEND_OTP: ({ commit }, tel) => {
    return new Promise(async (resolve, reject) => {
      let { data } = await axios.post('/service-team/request-otp', {
        tel: tel
      })
      if (!data.error) {
        console.log(data)
        commit('UPDATE_MEMBER_ID', data.member.id)
        commit('UPDATE_ISREQUEST_OTP', true)
        resolve(data)
      } else {
        reject(data.message)
      }
    })
  },
  SUBMIT_OTP: ({ commit }, queryData) => {
    return new Promise(async (resolve, reject) => {
      let { data } = await axios.post('/service-team/submit-otp', {
        otp: queryData.otp,
        member_id: queryData.member_id
      })
      if (!data.error) {
        console.log(data)
        commit('UPDATE_STATUS_LOGIN', true)
        commit('UPDATE_MEMBER', data.member)
        resolve(data)
      } else {
        reject(data.message)
      }
    })
  },
  CHECK_STATUS_WORK: ({ commit, state }, queryData) => {
    return new Promise(async (resolve, reject) => {
      if (state.hasLogin && state.member) {
        let { data } = await axios.post('service-team/check-status-work', {
          member_id: state.member.id
        })
        if (parseInt(data.can_work) === 0) {
          commit('UPDATE_STATUS_LOGIN', false)
          commit('CLEAR_DATA_STATE')
          reject(data.error)
        } else {
          resolve(true)
        }
      }
    })
  }
}

const mutations = {
  UPDATE_STATUS_LOGIN: (state, data) => {
    state.hasLogin = data
  },
  UPDATE_TEL: (state, data) => {
    state.tel = data
  },
  UPDATE_OTP: (state, data) => {
    state.otp = data
  },
  UPDATE_ISREQUEST_OTP: (state, data) => {
    state.isRequestingOtp = data
  },
  UPDATE_MEMBER_ID: (state, data) => {
    state.memberId = data
  },
  UPDATE_MEMBER: (state, data) => {
    state.member = data
  },
  CLEAR_DATA_STATE: (state, data) => {
    state.tel = ''
    state.otp = ''
    state.isRequestingOtp = false
    state.hasLogin = false
    if (state.member) {
      state.member = null
      state.memberId = ''
    }
  }
}

const getters = {
  getHasLogin: state => {
    return state.hasLogin
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/service.team.js